<template>
  <AddPosts />
</template>
<script>
import appConfig from '@/app.config'
import AddPosts from '../../../components/dadban/posts/AddPosts.vue'
export default {
  page: {
    title: 'اضافه کردن پست',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-posts',
  components: {
    AddPosts,
  },
}
</script>
